module.exports = __webpack_public_path__ + "fonts/Raleway-ThinItalic.8fe060be.ttf";